import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Modal } from "semantic-ui-react";

import { useRedirect } from "data/hub/hooks";

import { useTemplates } from "./hooks";
import { Header, NavigationBar, TemplatesList } from "./components";

const navItems = [
  { name: "All Templates", slug: "all" },
  { name: "Hubly", slug: "hubly" },
  { name: "Partners", slug: "partners" },
  { name: "Installed", slug: "installed" },
];

export function Templates() {
  const redirect = useRedirect();
  const { section } = useParams();
  const history = useHistory();

  const page = useTemplates(section, redirect);

  useEffect(() => {
    const isValidSection = navItems.find(({ slug }) => {
      return slug === section;
    });

    if (!isValidSection) {
      const { pathname } = history.location;

      const sectionIndex = pathname.lastIndexOf("/");

      history.replace(
        `${pathname.substring(0, sectionIndex + 1)}${navItems[0].slug}`
      );
    }
  }, [history, section]);

  return (
    <Modal open size="large" onClose={redirect} style={{ height: "90%" }}>
      <Modal.Content image style={{ padding: "1em" }}>
        <NavigationBar
          data-test="template-navigation-menu"
          style={{ width: "17%", marginRight: "3%" }}
          items={navItems}
          selected={section}
          disabled={page.loading}
          onSelected={(slug) => {
            return redirect(`templates/${slug}`);
          }}
        />

        <Modal.Content style={{ padding: "0", width: "80%" }}>
          <Header onClose={redirect} />
          <Modal.Content
            style={{ height: "85vh", overflow: "auto" }}
            data-test="templates-list"
          >
            <TemplatesList templates={page} />
          </Modal.Content>
        </Modal.Content>
      </Modal.Content>
    </Modal>
  );
}

export default Templates;
